import { ErrorBoundary } from '@core-web/ui';
import { RouterManager } from '@apps/route';
import { ThemeProvider } from '@echotex/theme';
import CssBaseline from '@mui/material/CssBaseline';
import { ReduxGate } from '@core-web/redux';
import { GlobalContextProvider } from '@core-web/context';
import { AppConfiguration } from '@echotex/app-configuration';
import { GlobalStyle } from '../styles/GlobalStyle';

export const AppRoot = (): JSX.Element => (
  <ErrorBoundary>
    <ThemeProvider>
      <ReduxGate>
        <CssBaseline />
        <GlobalStyle />
        <GlobalContextProvider>
          <RouterManager />
          <AppConfiguration />
        </GlobalContextProvider>
      </ReduxGate>
    </ThemeProvider>
  </ErrorBoundary>
);
